export default function switchToRMAService($http, $location, $cookies, $window, NotificationService, sessionService, ENVIRONMENT, SWITCH_TO_COOKIE_KEY,
                                           SWITCH_TO_BC_CONFIG, SWITCH_TO_RMA_CONFIG) {

  return { switchToRMA };

  function switchToRMA(merchant) {
    if (!merchant.id) {
      NotificationService.error('Invalid merchant ID');
      return;
    }

    $http.post(SWITCH_TO_BC_CONFIG.AUDIT_ENDPOINT + '/' + merchant.id, {}).then(function (res) {
      if (res.data) {
        const sessionToken = res.data;
        if (!sessionToken) {
          NotificationService.error('Invalid session token');
          return;
        }

        $window.location = `${SWITCH_TO_RMA_CONFIG.RMA_LOCATION}?merchantId=${merchant.id}&sessionToken=${sessionToken}`;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/switchToRMA.service.js